import * as React from 'react';
import { Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { TextField } from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';

export const TYPE = 'mui-select';

type Option = {
  value: string;
  label: string;
};

export class MuiSelectModel extends Question {
  getType(): string {
    return TYPE;
  }

  get choices() {
    return this.getPropertyValue('choices');
  }
  set choices(val) {
    this.setPropertyValue('choices', val);
  }
}

export class MuiSelect extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  get question() {
    return this.questionBase;
  }

  get choices() {
    return this.question.choices;
  }

  handleChange(_: React.ChangeEvent<HTMLInputElement>, { value }: Option) {
    this.question.value = value;
  }

  protected renderElement(): JSX.Element | null {
    const { value = '', title, isRequired, errors } = this.question;
    const error = errors.length > 0;

    const filterOptions = createFilterOptions({
      matchFrom: 'start',
      stringify: (option: Option) => option.label
    });

    return (
      <Autocomplete
        value={this.choices.find((option: Option) => option.value === value) || null}
        options={this.choices}
        getOptionLabel={option => option.label}
        onChange={this.handleChange}
        filterOptions={filterOptions}
        renderInput={params => (
          <TextField
            {...params}
            label={title}
            variant="outlined"
            required={isRequired}
            fullWidth
            error={error}
            helperText={error && errors[0].locText.text}
          />
        )}
      />
    );
  }
}
